// extracted by mini-css-extract-plugin
export default {"button":"RemovePopup_button__PvlXL"};